import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import * as actions from "../../_redux/attendance/AttendanceAction";
import { AbsenteeismStatusOptions, CustomSelect, redirectToPages, today } from "../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { StudentsPage } from "./students/StudentsPage";

export function StudentAbsenteeismsPage({
  match: {
    params: { id, dateParam }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  const [date, setDate] = useState(dateParam ?? today);
  const [sectionId, setSectionId] = useState(id);
  const [absenteeismStatus, setAbsenteeismStatus] = useState();
  const [isApplication, setIsApplication] = useState();
  const [isMail, setIsMail] = useState();
  const [isSms, setIsSms] = useState();
  
  // Getting curret state of Student Absenteeisms from store (Redux)
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, sections } = useSelector(
    (state) => ({
      actionsLoading: state.attendance.actionsLoading,
      isSuccess: state.attendance.isSuccess,
      type: state.attendance.type,
      sections: state.attendance.sections
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getSections());
    return () => dispatch(actions.cleanAttendanceState());
  }, [dispatch]);
  
  useEffect(() => {
    let _title = "Öğrenci Devamsızlıkları";
    setTitle(_title);
    subheader.setTitle(_title);
  }, [subheader]);
    
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <>
      <Card>
        { actionsLoading && <ModalProgressBar /> }
        <CardHeader title={title} />
        <CardBody>
          <div className="form-group row">
            <div className="col-1 mt-3">
              Tarih
            </div>
            <div className="col-3">
              <input
                type="date"
                value={date}
                className="form-control"
                max={new Date().toJSON().slice(0, 10)}
                onChange={e => setDate(e.target.value)}
              />
            </div>
            <div className="col-2"></div>
            <div className="col-1 mt-3">
              Durum
            </div>            
            <div className="col-3">
              <CustomSelect
                options={AbsenteeismStatusOptions}                
                onChange={option => setAbsenteeismStatus(option.value)}
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-1 mt-3">
              Sınıf
            </div>
            <div className="col-3">
              <CustomSelect
                options={sections}
                value={sectionId}
                onChange={option => setSectionId(option.value)}
              />
            </div>
            <div className="col-2"></div>
            <div className="col-1 mt-3">
              Bildirim
            </div>
            <div className="col-4">
              <Form.Check 
                inline
                type="checkbox"
                className="mt-3 mr-18"
                label="Uygulama"                
                onChange={e => setIsApplication(e.target.checked)}
              />
              <Form.Check 
                inline
                type="checkbox"
                className="mt-3 mr-18"
                label="Mail"
                onChange={e => setIsMail(e.target.checked)}
              />
              <Form.Check 
                inline
                type="checkbox"
                className="mt-3"
                label="SMS"
                onChange={e => setIsSms(e.target.checked)}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <StudentsPage
        date={date}
        sectionId={sectionId}
        absenteeismStatus={absenteeismStatus}
        isApplication={isApplication}
        isMail={isMail}
        isSms={isSms}
      />
    </>    
  );
}